/**
 * ImportCustomerBasePage — Item 391-C · rota /admin/organizacao/importar-base.
 *
 * Tela do admin para importar a base de clientes do tenant (CSV). Gate próprio
 * na página (`customer-registry-import`) — não confiar só na rota protegida
 * (padrão D-B das telas de Configuração). A View assume a cap concedida.
 */

import { CapabilityLockedBanner } from '@lume/ui-components';

import { ImportCustomerBaseView } from '../features/customer-registry/ImportCustomerBaseView';
import { useCapability } from '../hooks/use-capability';

import '../features/customer-registry/customer-registry.css';

export function ImportCustomerBasePage(): JSX.Element {
  const canImport = useCapability('customer-registry-import');

  if (!canImport) {
    return (
      <div className="cr-screen cr-screen--gate">
        <CapabilityLockedBanner
          capability="customer-registry-import"
          tierMin="professional"
          fallbackMessage="A importação da base de clientes é restrita a administradores do tenant em planos Professional ou superior."
        />
      </div>
    );
  }

  return <ImportCustomerBaseView />;
}
